var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Calendar extends Component {
    constructor() {
        super('Calendar', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Calendar.target = (!$('body').hasClass('page-template-calendar') || ($(window).width() < 991 && $('body').hasClass('page-template-season'))) ? $('.calendar:not(.calendar-static)').eq(0) : $('.calendar').eq(1);
            if (Calendar.target.length > 0) {
                Calendar.month = (Calendar.target.data('month')) ? parseInt(Calendar.target.data('month')) : (new Date()).getMonth() + 1;
                Calendar.year = (Calendar.target.data('year')) ? parseInt(Calendar.target.data('year')) : (new Date()).getFullYear();
                Calendar.monthCount = (Calendar.target.data('monthCount')) ? parseInt(Calendar.target.data('monthCount')) : 3;
                Calendar.loadCalendar();
                $(document).on('click', '.btn-calendar-previous', (event) => {
                    event.preventDefault();
                    Calendar.month -= Calendar.monthCount;
                    if (Calendar.month < 1) {
                        Calendar.month = 10;
                        Calendar.year -= 1;
                    }
                    Calendar.loadCalendar();
                });
                $(document).on('click', '.btn-calendar-next', (event) => {
                    event.preventDefault();
                    Calendar.month += Calendar.monthCount;
                    if (Calendar.month > 12) {
                        Calendar.month -= 12;
                        Calendar.year += 1;
                    }
                    Calendar.loadCalendar();
                });
                $('#btn-toggle-calendar').on('click', (event) => {
                    event.preventDefault();
                    $('#calendar-container').toggleClass('d-none');
                });
            }
            $(window).on('resize', () => { Calendar.setCalendarHeight(); });
            this.success();
        });
    }
    static setCalendarHeight() {
        if (!$('body').hasClass('page-template-calendar'))
            return;
        let height = Calendar.target.find('.month').height();
        Calendar.target.css('height', height + 'px');
    }
    static loadCalendar() {
        return __awaiter(this, void 0, void 0, function* () {
            Calendar.target.find('.calendar-loader').removeClass('d-none');
            Calendar.target.find('.calendar-content').remove();
            let calendarHTML = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                type: 'POST',
                body: {
                    action: 'load_calendar',
                    language: $('html').attr('lang'),
                    start_month: Calendar.month,
                    year: Calendar.year,
                    month_count: Calendar.monthCount,
                    selected_date: $('#current-date').text()
                }
            });
            Calendar.target.find('.calendar-loader').addClass('d-none');
            Calendar.target.append(calendarHTML);
            Calendar.setCalendarHeight();
        });
    }
}
